import { Flex, Text } from '@chakra-ui/react';
import { useCallback } from 'react';
import { useSnackbar } from 'ui-components';
import { Button } from 'ui-components/dist/Button';
import { Modal, ModalBody, ModalHeaderDefault } from 'ui-components/dist/Modal';
import { ALL_SOCIAL_PLATFORM_TYPE } from '~/constants';
import { useRemovePlatform } from '~/hooks/api/useRemovePlatform';
import { useEditPlatformsStore } from '~/screens/ManagePlatforms/EditPlatformsModal_DEPRECATED';
import { useRemovePlatformStore } from '~/screens/ManagePlatforms/RemovePlatformModal';
import { ICreator } from '~/types';

type Props = {
  withEdit?: boolean; // Controls whether back button should open edit platforms modal
};

export const RemovePlatformModal = ({ withEdit = true }: Props) => {
  const removePlatform = useRemovePlatform();

  const snackbar = useSnackbar();

  const { platform, creatorId, isModalOpen, setIsModalOpen } =
    useRemovePlatformStore();
  const { openModal: openEditPlatformModal, showPlatforms } =
    useEditPlatformsStore();

  const handleBack = useCallback(() => {
    if (withEdit) openEditPlatformModal();
    setIsModalOpen(false);
  }, [openEditPlatformModal, setIsModalOpen, withEdit]);

  const handleSuccess = useCallback(
    (data: ICreator) => {
      setIsModalOpen(false);
      if (withEdit) showPlatforms(data);
      snackbar.success({
        description: 'Platform successfully removed',
      });
    },

    [setIsModalOpen, showPlatforms, snackbar, withEdit],
  );

  const handleRemovePlatform = () => {
    removePlatform.mutate(
      {
        id: creatorId,
        platform: platform as ALL_SOCIAL_PLATFORM_TYPE,
      },
      {
        onSuccess: handleSuccess,
      },
    );
  };

  return (
    <Modal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} size="sm">
      <ModalHeaderDefault title="Remove platform?" />
      <ModalBody>
        <Text fontSize="lg" fontWeight="400" lineHeight="16px">
          All data related to this platform will also be removed. Are you sure
          you want to remove it?
        </Text>

        <Flex justifyContent="flex-end" marginTop={4} gap={2}>
          <Button variant="tertiary" size="md" onClick={handleBack}>
            {withEdit === false ? 'Cancel' : 'Back'}
          </Button>
          <Button
            variant="danger"
            size="md"
            isDisabled={removePlatform.isLoading}
            trackId="foam-talent-remove-platform"
            onClick={handleRemovePlatform}
          >
            Remove
          </Button>
        </Flex>
      </ModalBody>
    </Modal>
  );
};
